module.exports = __webpack_public_path__ + "static/Feather-6beba7e6834963f7f171d3bdd075c915.ttf";